module.exports = __webpack_public_path__ + "img/xm08-ae8065.png";